import React from "react";
import Image from "./Image";
import NoProductImg from "../Assests/noProdImg.svg";

const NoProductsAvailable = () => {
  return (
    <div className="no-products" style={{ marginBottom: "50px" }}>
      <Image src={NoProductImg} style={{ maxWidth: "300px", margin: "auto" }} />
      No products available.
    </div>
  );
};

export default NoProductsAvailable;
